import { render, staticRenderFns } from "./userDocuments.vue?vue&type=template&id=01818f0d&scoped=true&"
import script from "./userDocuments.vue?vue&type=script&lang=js&"
export * from "./userDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01818f0d",
  null
  
)

export default component.exports